import settings from "./settings";
import Cookies from "js-cookie";
import Common from "./Common";

export default class FormManager {

    /**
     *
     */
    constructor() {
        this.isCalc = false;
    }


    /**
     * レシート情報をCookieに保存
     */
    saveCookies() {
        let $receiptBlock = $(settings.selector.receiptBlock);
        let $prizeBlock = $(settings.selector.prizeBlock);
        let $userBlock = $(settings.selector.userBlock);
        let $inquiryBlock = $(settings.selector.inquiryBlock);
        let saveObj = {
            "receipts": {},
            "prize": {},
            "user": {},
            "inquiry": {}
        };

        // 各ブロックから入力値を抽出

        // レシート
        $receiptBlock.find("input:not([type=hidden]), select, textarea").each((index, elem) => {
            let $elem = $(elem);
            let targetValue = Common.getFormValues($elem);


            if (targetValue !== false) {
                saveObj.receipts[$elem.attr("id")] = targetValue;
            }
        });

        // 賞品
        $prizeBlock.find("input:not([type=hidden]), select, textarea").each((index, elem) => {
            let $elem = $(elem);
            let targetValue = Common.getFormValues($elem);

            if (targetValue !== false) {
                saveObj.prize[$elem.attr("name")] = targetValue;
            }
        });


        // アンケート
        $inquiryBlock.find("input:not([type=hidden]), select, textarea").each((index, elem) => {
            let $elem = $(elem);
            let targetValue = Common.getFormValues($elem);

            if (targetValue !== false) {
                if ($elem.attr("type") === "checkbox" || $elem.attr("type") === "radio") {
                    if (!Array.isArray(saveObj.inquiry[$elem.attr("id")])) {
                        saveObj.inquiry[$elem.attr("id")] = []
                    }
                    saveObj.inquiry[$elem.attr("id")].push(targetValue);
                } else {
                    saveObj.inquiry[$elem.attr("id")] = targetValue;
                }
            }
        });

        Cookies.set(settings.appName, saveObj);

    }

    /**
     * Cookiesからユーザー情報を復元
     */
    restoreUserData() {
        this.restoreCookies("user", settings.selector.userBlock);
    }

    /**
     * Cookiesからアンケート情報を復元
     */
    restoreInquiryData() {
        this.restoreCookies("inquiry", settings.selector.inquiryBlock, "id");
    }

    /**
     * cookiesからデータ復元
     * @param target
     * @param targetBlock
     * @returns {boolean}
     */
    restoreCookies(target, targetBlock, targetAttr = "name") {
        let data = Cookies.getJSON(settings.appName);

        // cookiesが無効な場合の中断処理
        if (!data || !data[target]) return false;

        $(targetBlock).find("input:not([type=hidden]), select, textarea").each((index, elem) => {
            let labelName;
            labelName = $(elem).attr(targetAttr);

            if (data[target][labelName]) {
                Common.insertFormValues($(elem), data[target][labelName]);
            }
        });
    }

    /**
     * Cookiesからレシート・賞品を削除
     */
    clearReceiptsFromCookies() {

        // Cookiesが存在しない場合終了する
        if (typeof Cookies.getJSON(settings.appName) === "undefined") return false;

        // アンケート・個人情報は保持するため、一旦Cookiesをロードのうえ削除する
        let currentCookies = Cookies.getJSON(settings.appName);

        delete currentCookies.receipts;
        delete currentCookies.prize;

        Cookies.set(settings.appName, currentCookies);
    }

    /**
     * Cookiesを削除
     */
    clearAllCookies() {
        Cookies.set(settings.appName, null);
    }

}
